import { hydrateRoot } from 'react-dom/client';

import { PromoApplication } from 'shared/containers/App';
import { IApplicationContext } from 'shared/types/applicationContext';
import { parseHtml } from 'shared/utils/parseHtml';

interface IDependencies {
  context: IApplicationContext;
}

export async function renderPromoApplication(dependencies: IDependencies): Promise<void> {
  const { context } = dependencies;
  const { config } = context;

  const projectName = config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  await waitForMarkup();

  const RAW_MARKUP = window.__RAW_MARKUP__ as string;

  const children = parseHtml(RAW_MARKUP);

  hydrateRoot(rootElement, <PromoApplication context={context}>{children}</PromoApplication>);
}

export function waitForMarkup(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (window.__RAW_MARKUP__) {
      resolve();

      return;
    } else {
      // oxlint-disable-next-line prefer-const
      let timeout: number;

      const rawMarkupElement = document.getElementById('rawMarkup');
      if (!rawMarkupElement) {
        reject(new Error('Element #rawMarkup not found'));

        return;
      }
      rawMarkupElement.addEventListener('load', () => {
        window.clearTimeout(timeout);
        resolve();
      });

      timeout = window.setTimeout(() => {
        reject(new Error('RAW_MARKUP is not provided'));
      }, 5000);
    }
  });
}
